import {spacing} from "@khanacademy/wonder-blocks-tokens";

// This styling is applied on blocks to achieve a visual gap between sibling
// elements.
export const blockStyle = {
    margin: 0,
    ":not(:first-child)": {
        marginTop: spacing.medium_16,
    },
    ":not(:last-child)": {
        marginBottom: spacing.medium_16,
    },
} as const;
